// extracted by css-extract-rspack-plugin
module.exports =  {"service":"ServiceCell__service___UGrWo"};